import { render, staticRenderFns } from "./msg-tpl.vue?vue&type=template&id=088b1ddd&scoped=true"
import script from "./msg-tpl.vue?vue&type=script&lang=js"
export * from "./msg-tpl.vue?vue&type=script&lang=js"
import style0 from "./msg-tpl.vue?vue&type=style&index=0&id=088b1ddd&prod&lang=scss&scoped=true"
import style1 from "./msg-tpl.vue?vue&type=style&index=1&id=088b1ddd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088b1ddd",
  null
  
)

export default component.exports